/**
 * Core
 */
import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import { simplyClick, validateName } from "../../helpers";
import ButtonGroup from "../ButtonGroup";
import InputGlobal from "../InputGlobal";
import { errorEventsName } from "../../constants/index";
/**
 *Styles
 */
import "./Name.scss";
import Tooltip from "../Tooltip";

const Name = ({ setStep, step }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorName, setErrorName] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const handlerSubmit = () => {
    const { status, error = { text: "", type: "" } } = validateName(
      data?.first_name ?? ""
    );

    if (error.type) {
      simplyClick(errorEventsName[error.type]);
    }

    if (status) {
      simplyClick("cl_lnd_qm3_step3_next");
      setStep(step + 1);
    } else {
      setErrorName(error.text);
    }
  };

  const handleChangeName = (e) => {
    setErrorName(null);
    setShowTooltip(false);
    setData({ ...data, first_name: e.target.value });
  };

  const handlerStepBack = () => {
    setStep(step - 1);
    simplyClick("cl_lnd_qm3_step3_back");
  };

  return (
    <div className="global__form-wrap">
      <div className="name__form">
        <span className="line" />
        <h5 className="form__title">
          We help lonely people from all over the world build connections.
        </h5>
        <p className="name__text">
          If you’re ready to join the fun, set a username
        </p>
        <div className="name__input">
          <div className="has-float-label">
            <InputGlobal
              className={"input__global" + (errorName ? " error" : "")}
              onChange={(e) => handleChangeName(e)}
              name={"name__3"}
              placeholder={"Enter your username"}
              type={"text"}
              id={"name__3"}
              onBlur={() => setShowTooltip(false)}
              value={data.first_name ? data.first_name : ""}
              onFocus={() => {
                if (!data.first_name) {
                  setShowTooltip(true);
                }
                simplyClick("cl_lnd_qm3_step3_type_name");
              }}
            />
            <label htmlFor="name__3" className={errorName ? "error" : ""}>
              Enter your username
            </label>
            {errorName && <p className="error-text">{errorName}</p>}
            <Tooltip
              text="Your name must include at least 2 English letters. No numbers or special characters are allowed."
              showTooltip={showTooltip}
            />
          </div>
        </div>
        <p className="name__text">You can change it anytime</p>
      </div>
      <ButtonGroup cbStepNext={handlerSubmit} cbStepBack={handlerStepBack} />
    </div>
  );
};

export default Name;
